import { registerLicense } from "@syncfusion/ej2-base";

export function initializeSyncfusion() {
  registerLicense(process.env.NEXT_PUBLIC_SYNC_FUSION_LICENSE_KEY);
}
